module.exports = __webpack_public_path__ + "static/media/ekspozytory_02_A.f196da7e.png";